/**
 * @generated SignedSource<<b035199b3f36d42835a6f499a61ee7c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarEditDeleteMutation$variables = {
  calendarId: string;
};
export type CalendarEditDeleteMutation$data = {
  readonly store: {
    readonly calendar: {
      readonly delete: {
        readonly id: string;
        readonly store: {
          readonly calendarAddSuggestions: ReadonlyArray<{
            readonly iCalUrl: string;
            readonly title: string;
          }>;
        };
      };
    };
  };
};
export type CalendarEditDeleteMutation = {
  response: CalendarEditDeleteMutation$data;
  variables: CalendarEditDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "calendarId",
    "variableName": "calendarId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarSuggestion",
  "kind": "LinkedField",
  "name": "calendarAddSuggestions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iCalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarEditDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreCalendarMutation",
            "kind": "LinkedField",
            "name": "calendar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "delete",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarEditDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StoreCalendarMutation",
            "kind": "LinkedField",
            "name": "calendar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "delete",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2103a5445e53867b4790a9a68570618e",
    "id": null,
    "metadata": {},
    "name": "CalendarEditDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarEditDeleteMutation(\n  $calendarId: ID!\n) {\n  store {\n    calendar(calendarId: $calendarId) {\n      delete {\n        id\n        store {\n          calendarAddSuggestions {\n            iCalUrl\n            title\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44a889b98665076b745aea9e40bb252f";

export default node;
